import React from 'react';

const Card = ({ title, children, color = 'blue', tooltip, className = '' }) => {
  const colorStyles = {
    green: { borderColor: '#10b981', backgroundColor: 'rgba(16, 185, 129, 0.1)' },
    red: { borderColor: '#ef4444', backgroundColor: 'rgba(239, 68, 68, 0.1)' },
    orange: { borderColor: '#f97316', backgroundColor: 'rgba(249, 115, 22, 0.1)' },
    yellow: { borderColor: '#eab308', backgroundColor: 'rgba(234, 179, 8, 0.1)' },
    blue: { borderColor: '#3b82f6', backgroundColor: 'rgba(59, 130, 246, 0.1)' },
    purple: { borderColor: '#8b5cf6', backgroundColor: 'rgba(139, 92, 246, 0.1)' },
    gray: { borderColor: '#6b7280', backgroundColor: 'rgba(107, 114, 128, 0.1)' }
  };

  const cardStyle = {
    borderRadius: '0.5rem',
    border: `2px solid`,
    padding: '1rem',
    ...colorStyles[color],
    marginBottom: '1rem'
  };

  return (
    <div style={cardStyle} className={className}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
        <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#fff' }}>{title}</h3>
        {tooltip && (
          <div style={{ position: 'relative' }}>
            <svg style={{ width: '1.25rem', height: '1.25rem', color: '#9ca3af', cursor: 'help' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div title={tooltip} style={{ position: 'absolute', display: 'none' }}>
              {tooltip}
            </div>
          </div>
        )}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {children}
      </div>
    </div>
  );
};

export default Card;